import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import EventCard from "../components/EventCard";
import FollowButton from "../components/FollowButton";
import { Instagram, ShieldCheck, Users } from "lucide-react";

export default function OrganizerPage() {
  const { id } = useParams();
  const { user } = useAuth();
  const [o, setO] = useState(null);
  useEffect(() => { api.get(`/organizers/${id}`).then(({ data }) => setO(data)).catch((e) => toast.error(formatApiError(e))); }, [id, user]);
  if (!o) return <div className="flex min-h-[50vh] items-center justify-center"><div className="h-8 w-8 animate-spin rounded-full border-2 border-amber-500 border-t-transparent" /></div>;
  return (
    <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6">
      <div className="mb-10 flex flex-col gap-6 rounded-3xl border border-zinc-800 bg-[#3A1020] p-8 noise sm:flex-row sm:items-center sm:justify-between">
        <div>
          <div className="font-mono text-[10px] uppercase tracking-widest text-amber-400">Organizer</div>
          <h1 data-testid="organizer-name" className="font-display text-3xl font-extrabold text-zinc-50 sm:text-4xl">{o.name}</h1>
          <div className="mt-3 flex flex-wrap gap-4 text-sm text-zinc-400">
            {o.verification_status === "verified" && <span className="flex items-center gap-1 text-amber-400"><ShieldCheck className="h-4 w-4" /> PAN verified</span>}
            {o.instagram_handle && <a href={`https://instagram.com/${o.instagram_handle}`} target="_blank" rel="noreferrer" className="flex items-center gap-1 hover:text-blush"><Instagram className="h-4 w-4" /> @{o.instagram_handle}</a>}
            <span data-testid="follower-count" className="flex items-center gap-1"><Users className="h-4 w-4" /> {o.followers} follower{o.followers === 1 ? "" : "s"}</span>
          </div>
        </div>
        <FollowButton organizerId={o.id} initialFollowing={o.following} initialCount={o.followers} onChange={(f, c) => setO({ ...o, following: f, followers: c })} />
      </div>
      <h2 className="mb-4 font-display text-2xl font-extrabold text-zinc-50">Upcoming drops</h2>
      {o.events.length === 0 ? <div className="rounded-2xl border border-zinc-800 bg-[#3A1020] p-10 text-center text-sm text-zinc-500">Nothing on sale yet — follow to hear first.</div>
        : <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">{o.events.map((e) => <EventCard key={e.id} event={e} />)}</div>}
    </div>
  );
}
